import { createReducer } from '@reduxjs/toolkit';
import { RequestError, StationsTemplatesPreview } from 'types';
import { fetchStationsTemplatesPreview, fetchedStationsTemplatesPreview } from './actions';

import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  data: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchStationsTemplatesPreview, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchedStationsTemplatesPreview, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.data = payload as StationsTemplatesPreview;
        state.error = undefined;
        state.status = 'success';
      }
    })
);
